import React, {
  useEffect,
  useState,
} from 'react';
import { observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { useStores } from '../../hooks/use-stores';
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Row,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import { displayDate } from '../../utils/date';

const MaterialHistoryForm = observer((props) => {
  const { editData, onSubmit = () => {}, onCancel = () => {}, t } = props;
  const { materialStore, shipHistoryStore, notifierStore, newAuthStore } = useStores();
  const [ data, setData ] = useState();
  const { user } = newAuthStore;

  useEffect(() => {
    setData(editData);
  }, [editData]);

  const onChange = (value, name) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const onSave = () => {
    materialStore.changeMaterialInventoryHistory(data)
      .then(() => {
        shipHistoryStore.loadHistory();
        materialStore.loadMaterials();
        notifierStore.showInfo('Material history saved successfully!');
        onSubmit();
      })
      .catch(e => {
        notifierStore.showError(`${e.message}`);
      });

  };

  return !data ? '' : (
    <div>
      <h4>{t('Edit')}</h4>
      <ul>
        <li>{t('Date')}: {displayDate(data.date, materialStore.timezone, 'L LT', user.language)}</li>
        <li>{t('Type')}: {data.type}</li>
        <li>{t('User')}: {data.userName}</li>
        {data.vendorCode && <li>{t('Vendor')}: {data.vendorCode}</li>}
        {data.bin && <li>{t('Bin')}: {data.truck}</li>}
        {data.truck && <li>{t('Truck')}: {data.truck}</li>}
        {data.reasonCodeDescription && <li>{t('Reason')}: {data.reasonCodeDescription}</li>}
      </ul>
      <Form onSubmit={e => e.preventDefault()}>
        <Row className="form-fields">
          <Col sm={4}>
            <ControlLabel>{t('Quantity')}</ControlLabel>
            <FormGroup>
              <FormControl
                name="quantity"
                type="number"
                value={data.quantity || ''}
                onChange={e => onChange(e.target.value, 'quantity')}
              />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <ControlLabel>{t('Ticket')}</ControlLabel>
            <FormGroup>
              <FormControl
                name="ticket"
                type="number"
                value={data.ticket || ''}
                onChange={e => onChange(e.target.value, 'ticket')}
              />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <FormGroup>
              <ControlLabel>{t('Comment')}</ControlLabel>
              <FormControl
                name="comment"
                componentClass="textarea"
                type="text"
                value={data.comment || ''}
                onChange={e => onChange(e.target.value, 'comment')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="form-fields">
          <Col sm={4}>
            <ControlLabel>{t('BOL Quantity')}</ControlLabel>
            <FormGroup>
              <FormControl
                name="bolQuantity"
                type="number"
                value={data.bolQuantity || ''}
                onChange={e => onChange(e.target.value, 'bolQuantity')}
              />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <ControlLabel>{t('BOL Ticket')}</ControlLabel>
            <FormGroup>
              <FormControl
                name="bolTicket"
                type="number"
                value={data.bolTicket || ''}
                onChange={e => onChange(e.target.value, 'bolTicket')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="form-buttons">
          <Col sm={12} className="text-right">
            <Button onClick={onCancel}>{t('Close')}</Button>
            {' '}
            <LoadingButton
              bsStyle="primary"
              onClick={onSave}
              label={t('Save')}
              loadingLabel={t('Save')}
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
});

export default withTranslation()(MaterialHistoryForm);
